<div>
  <app-page>
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      >
      </dx-button>
      @if(!editingMode){
        <dx-button
          class="cta-btn"
          type="normal"
          [text]="'COMMON.SAVE' | translate"
          (click)="submit()"
        ></dx-button>
      } @else {
        <dx-drop-down-button
          [splitButton]="true"
          [text]="'COMMON.SAVE' | translate"
          stylingMode="contained"
          type="normal"
          [dropDownOptions]="{ width: 230 }"
          (onButtonClick)="submit()"
        >
          <dxi-item (click)="openDeleteTextTemplateConfirmationModal()">{{
            "COMMON.DELETE" | translate
          }}</dxi-item>
        </dx-drop-down-button>
      }
    </div>
    <app-panel *ngIf="generalFormData">
      <app-page-title
        [title]="
          editingMode
            ? ('ADMINISTRATION.TEXT-TEMPLATE-TITLE-EDIT' | translate)
            : ('ADMINISTRATION.TEXT-TEMPLATE-TITLE-ADD' | translate)
        "
      ></app-page-title>
      <app-panel [title]="'ADMINISTRATION.GENERAL' | translate">
        <dx-form
          #generalForm
          [formData]="generalFormData"
          labelMode="floating"
        >
          <dxi-item 
            itemType="group" 
            [colCount]="5" [colSpan]="5"
          >
            <dxi-item
              dataField="name"
              [colSpan]="3"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.NAME' | translate">
              </dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.NAME-REQUIRED' | translate">
              </dxi-validation-rule>
            </dxi-item>

            <dxi-item
              dataField="type"
              editorType="dxSelectBox"
              [colSpan]="2"
              [editorOptions]="templateTypes"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.TEXT-TEMPLATE-TYPE' | translate">
              </dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.TEXT-TEMPLATE-TYPE-REQUIRED' | translate">
              </dxi-validation-rule>
            </dxi-item>
          </dxi-item>
        </dx-form>
      </app-panel>
      <app-panel [title]="'ADMINISTRATION.CONTENT' | translate">
        <app-expandable-text-editor
          #contentEditor
          [required]="true"
          [(value)]="generalFormData.content"
        ></app-expandable-text-editor>
      </app-panel>
    </app-panel>
  </app-page>
</div>

@if(showDeleteTemplateModal){
  <app-confirmation-dialog
    [height]="'auto'"
    [(showModal)]="showDeleteTemplateModal"
    (submit)="deleteTextTemplate()"
    [options]="modalDeleteTemplateConfirmationOptions"
  ></app-confirmation-dialog>
}

